import moment from 'moment';
import 'daterangepicker';
import 'daterangepicker/daterangepicker.css';
import daterangePickerPtBr from '../entrypoints/src/admin/i18n/daterange-picker.pt-br';
import AjaxLoader from '../entrypoints/src/admin/utilities/ajax-loader';
import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    moment.locale('pt-BR');
    this.$fmFilterTuition = this.element.querySelector('form');
		this.dateRangePicker();

		return this;
  }

	dateRangePicker() {
    if ($('.professor-commission-daterangepicker').length == 0) {
        return;
    }

    let _this = this;

    $('.professor-commission-daterangepicker').each((_, el) => {
      let picker = $(el),
        startDate = moment(picker.data('startDate')),
        endDate = moment(picker.data('endDate'));

      picker.daterangepicker({
          locale: daterangePickerPtBr,
          startDate: startDate,
          endDate: endDate,
          opens: 'left',
          applyButtonClasses: 'btn btn-sm btn-secondary',
          ranges: {
            'Mês Retrasado': [moment().subtract(2, 'month').startOf('month'), moment().subtract(2, 'month').endOf('month')],
            'Mês Passado': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
            'Esse Mês': [moment().startOf('month'), moment().endOf('month')]
          }
      }, (start, end) => {
        AjaxLoader.show();
        _this.element.querySelector('input[name="start_date"]').value = start.format('DD/MM/YYYY');
        _this.element.querySelector('input[name="end_date"]').value = end.format('DD/MM/YYYY');
        _this.$fmFilterTuition.submit();
      });

      this.initDateRangePicker(picker, startDate, endDate, 'Personalizado');
    });
	}

  collapseAll(ev) {
    ev.preventDefault();

    if (typeof this.collapseToggle === 'undefined')
      this.collapseToggle = false;

      this.collapseToggle = !this.collapseToggle;
    $(this.element.querySelectorAll('.collapse')).collapse(!!this.collapseToggle ? 'show' : 'hide');
  }

	initDateRangePicker(picker, start, end, label) {
		let title = '', range = '';

		if (label == 'Personalizado') {
			range = start.format('DD MMM YYYY') + ' - ' + end.format('DD MMM YYYY');
		} else {
			title = !!label ? label : 'Esse Mês';
			range = start.format('MMMM [de] YYYY');
		}

		picker.html(range);
	}
}